import { render, staticRenderFns } from "./personInfo.vue?vue&type=template&id=580aa6dc&scoped=true"
import script from "./personInfo.vue?vue&type=script&lang=js"
export * from "./personInfo.vue?vue&type=script&lang=js"
import style0 from "./personInfo.vue?vue&type=style&index=0&id=580aa6dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580aa6dc",
  null
  
)

export default component.exports